/* eslint-disable @typescript-eslint/naming-convention */
// Using a different case so that it'll match the casing in angular-new-payment-method-form
// and therefore constitute the same type.
var PaymentType;
(function (PaymentType) {
    PaymentType["USCard"] = "CREDIT";
    PaymentType["NonUSCard"] = "CREDIT_INTL";
    PaymentType["ECheck"] = "ECHECK";
})(PaymentType || (PaymentType = {}));

/* eslint-disable @typescript-eslint/naming-convention */
// Using a different case so that it'll match the casing in angular-new-payment-method-form
// and therefore constitute the same type.
var CardProvider;
(function (CardProvider) {
    CardProvider["Visa"] = "visa";
    CardProvider["MasterCard"] = "mastercard";
    CardProvider["AMEX"] = "amex";
    CardProvider["Discover"] = "discover";
    CardProvider["Other"] = "other";
})(CardProvider || (CardProvider = {}));
/* eslint-enable @typescript-eslint/naming-convention */
const cardName = (id, short = false) => {
    switch (id) {
        case CardProvider.Visa: return 'Visa';
        case CardProvider.MasterCard: return 'Mastercard';
        case CardProvider.AMEX: return short ? 'AMEX' : 'American Express';
        case CardProvider.Discover: return 'Discover';
        case CardProvider.Other: return short ? 'Card' : 'Credit Card';
    }
};

/*
 * Public API Surface of angular-payment-types
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CardProvider, PaymentType, cardName };

